import { HorizonInterval } from './Horizon';
import TractDetail from './tract_detail/TractDetail';
import Section from './Section';
import Township from './Township';

export default class CloneHorizon {
    private _currentLevel: 'Horizon' | 'Tract' | 'Section' | 'Township';
    performClone: boolean;
    private _townshipId: number;
    private _sectionNumber: number;
    private _tractNumber: number;
    private _horizonNumber: number;
    private _horizons: Array<HorizonInterval>;
    private _tracts: Array<TractDetail>;
    private _sections: Array<Section>;
    private _townships: Array<Township>;

    public get townshipId() {
        return this._townshipId;
    }

    public set townshipId(townshipId: number) {
        this._currentLevel = 'Township';
        this._townshipId = townshipId;
        this._sectionNumber = undefined;
        this._tractNumber = undefined;
        this._horizonNumber = undefined;
    }

    public get sectionNumber() {
        return this._sectionNumber;
    }

    public set sectionNumber(sectionNumber: number) {
        this._sectionNumber = sectionNumber;
        this.tractNumber = undefined;
        this.horizonNumber = undefined;
        this._currentLevel = sectionNumber ? 'Section' : 'Township';
    }

    public get tractNumber() {
        return this._tractNumber;
    }

    public set tractNumber(tractNumber: number) {
        this._tractNumber = tractNumber;
        this.horizonNumber = undefined;
        this._currentLevel = tractNumber ? 'Tract' : 'Section';
    }

    public get horizonNumber() {
        return this._horizonNumber;
    }

    public set horizonNumber(horizonNumber: number) {
        this._horizonNumber = horizonNumber;
        this._currentLevel = horizonNumber ? 'Horizon' : 'Tract';
    }

    public updateHorizons = (horizons: Array<HorizonInterval>) => {
        this._horizons = horizons;
    };

    public get horizons() {
        return this._horizons;
    }

    public updateTracts = (tracts: Array<TractDetail>) => {
        this._tracts = tracts;
        this._horizons = [];
    };

    public get tracts() {
        return this._tracts;
    }

    public updateSections = (sections: Array<Section>) => {
        this._sections = sections;
        this._tracts = [];
        this._horizons = [];
    };

    public get sections() {
        return this._sections;
    }

    public updateTownships = (townships: Array<Township>) => {
        this._townships = townships;
        this._sections = [];
        this._tracts = [];
        this._horizons = [];
    };

    public get townships() {
        return this._townships;
    }

    public set currentLevel(level: 'Horizon' | 'Tract' | 'Section' | 'Township') {
        this._currentLevel = level;
    }

    public get currentLevel() {
        return this._currentLevel;
    }

    constructor() {
        this.performClone = false;
    }
}



// WEBPACK FOOTER //
// ./src/models/CloneHorizon.ts